module.exports = __webpack_public_path__ + "img/apply.5ad87c91.png";